import { Component, Input } from '@angular/core';
import { TimeWindowForm } from '../../core/models/forms/TimeWindowForm';

@Component({
  selector: 'app-date-period-inputs',
  template: `
      <div class="d-flex gap-2" [formGroup]="form">
        <app-filter-date-input name="from" [dateInputClass]="dateInputClass"
                               [control]="form.from"></app-filter-date-input>
        <app-filter-date-input name="to" [dateInputClass]="dateInputClass"
                               [control]="form.to"></app-filter-date-input>
      </div>
  `,
})
export class DatePeriodInputsComponent {
  @Input() form: TimeWindowForm = new TimeWindowForm();
  @Input() dateInputClass = '';
}
